/* ============================================================
   SIUUP THEME JS
   ============================================================ */

/* ---- UTILS ---- */
const $ = id => document.getElementById(id);
const fmt = cents => {
  const currency = window.Shopify?.currency?.active || 'USD';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: 2 }).format(cents / 100);
};

/* ---- TOAST ---- */
let toastTimer;
function showToast(msg) {
  const toast = $('toast');
  const label = $('toastMsg');
  if (!toast || !label) return;
  label.textContent = msg;
  toast.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove('show'), 2200);
}

/* ---- CART DRAWER ---- */
const overlay    = $('overlay');
const drawer     = $('drawer');
const drawerFoot = $('drawerFoot');

function openCart() {
  drawer?.classList.add('open');
  overlay?.classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCart();
}
function closeCart() {
  drawer?.classList.remove('open');
  overlay?.classList.remove('open');
  document.body.style.overflow = '';
}

async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCart(cart);
  } catch (e) {}
}

function renderCart(cart) {
  const countEls = document.querySelectorAll('#cartCount, #drawerCount');
  countEls.forEach(el => { el.textContent = cart.item_count; });

  const items = $('drawerItems');
  if (!items) return;

  if (cart.item_count === 0) {
    items.innerHTML = `<div class="drawer-empty"><div class="ic">🛒</div><p>Your cart is empty.<br>Time to fix that.</p></div>`;
    drawerFoot && (drawerFoot.style.display = 'none');
    return;
  }

  items.innerHTML = cart.items.map(item => `
    <div class="line-item">
      <div class="thumb">
        ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
      </div>
      <div class="li-info">
        <div class="li-name">${item.product_title}</div>
        <div class="li-cat">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : ''}Qty ${item.quantity}</div>
        <button class="li-remove" data-key="${item.key}">Remove</button>
      </div>
      <div class="li-price">${fmt(item.final_price)}</div>
    </div>
  `).join('');

  const sub = cart.total_price;
  const subtotalEl = $('drawerSubtotal');
  if (subtotalEl) subtotalEl.textContent = fmt(sub);

  if (drawerFoot) drawerFoot.style.display = 'block';

  items.querySelectorAll('.li-remove').forEach(btn => {
    btn.addEventListener('click', () => removeItem(btn.dataset.key));
  });
}

async function removeItem(key) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  });
  refreshCart();
}

/* ---- ADD TO CART ---- */
async function addToCart(variantId, qty = 1, btn) {
  if (!variantId) return;
  const origHTML = btn?.innerHTML;
  if (btn) {
    btn.disabled = true;
    const lbl = btn.querySelector('.lbl');
    if (lbl) lbl.textContent = '✓ Added';
    btn.classList.add('added');
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    if (!res.ok) throw new Error();
    const data = await res.json();
    showToast(`${data.product_title} added`);
    openCart();
  } catch {
    showToast('Could not add to cart');
  } finally {
    setTimeout(() => {
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('added');
        const lbl = btn.querySelector('.lbl');
        if (lbl) lbl.textContent = 'Add to cart';
      }
    }, 1400);
  }
}

/* ---- PRODUCT PAGE ---- */
function initProductPage() {
  // Gallery thumbnails → scroll slider to matching index
  document.querySelectorAll('.product-gallery__thumb').forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      const slider = $('productSlider');
      if (slider) slider.scrollTo({ left: slider.offsetWidth * i, behavior: 'smooth' });
      document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // Slider scroll → sync indicators and thumbs
  const slider = $('productSlider');
  if (slider) {
    slider.addEventListener('scroll', () => {
      const idx = Math.round(slider.scrollLeft / slider.offsetWidth);
      document.querySelectorAll('.gallery-indicator').forEach((dot, i) => {
        dot.classList.toggle('active', i === idx);
      });
      document.querySelectorAll('.product-gallery__thumb').forEach((t, i) => {
        t.classList.toggle('active', i === idx);
      });
    }, { passive: true });
  }

  // Variant swatches — resolve correct variant from all selected options
  const variantsDataEl = document.getElementById('product-variants-data');
  if (variantsDataEl) {
    const allVariants = JSON.parse(variantsDataEl.textContent);

    // Seed selectedOptions from the initially active swatches
    const selectedOptions = {};
    document.querySelectorAll('.variant-swatch.active').forEach(s => {
      selectedOptions[s.dataset.optionPos] = s.dataset.optionVal;
    });

    function resolveVariant() {
      return allVariants.find(v =>
        Object.entries(selectedOptions).every(([pos, val]) => v['option' + pos] === val)
      ) || null;
    }

    function applyVariant(v) {
      if (!v) return;
      const form = $('productForm');
      if (form) form.querySelector('[name="id"]').value = v.id;

      // Price
      const cur = $('price-current');
      const cmp = $('price-compare');
      if (cur) cur.textContent = fmt(v.price);
      if (cmp) {
        if (v.compare_at_price > v.price) {
          cmp.textContent = fmt(v.compare_at_price);
          cmp.style.display = '';
        } else {
          cmp.style.display = 'none';
        }
      }

      // Button
      const atcBtn = $('atc-btn');
      const atcPrice = $('atc-price');
      if (atcBtn) {
        if (v.available) {
          atcBtn.disabled = false;
          atcBtn.type = 'submit';
          if (atcPrice) atcPrice.textContent = fmt(v.price);
        } else {
          atcBtn.disabled = true;
          atcBtn.type = 'button';
          atcBtn.innerHTML = 'Sold Out';
        }
      }

      // Buy now
      const buyNow = $('buy-now-btn');
      if (buyNow) {
        buyNow.href = `/cart?items[][id]=${v.id}&items[][quantity]=1&checkout=true`;
        buyNow.style.display = v.available ? '' : 'none';
      }
    }

    document.querySelectorAll('.variant-swatch').forEach(swatch => {
      swatch.addEventListener('click', () => {
        const pos = swatch.dataset.optionPos;
        selectedOptions[pos] = swatch.dataset.optionVal;

        // Update active within this group
        swatch.closest('.variant-swatches')
              ?.querySelectorAll('.variant-swatch')
              .forEach(s => s.classList.remove('active'));
        swatch.classList.add('active');

        // Update the label
        const label = document.getElementById('selected-val-' + pos);
        if (label) label.textContent = swatch.dataset.optionVal;

        applyVariant(resolveVariant());
      });
    });
  }

  // Qty buttons
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-control')?.querySelector('input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      val = btn.dataset.action === 'plus' ? Math.min(val + 1, 99) : Math.max(val - 1, 1);
      input.value = val;
    });
  });

  // Product form submit
  const form = $('productForm');
  form?.addEventListener('submit', async e => {
    e.preventDefault();
    const variantId = form.querySelector('[name="id"]')?.value;
    const qty = parseInt(form.querySelector('[name="quantity"]')?.value) || 1;
    const btn = form.querySelector('.add-to-cart-btn');
    await addToCart(variantId, qty, btn);
  });
}

/* ---- MOBILE MENU ---- */
function initMobileMenu() {
  $('openMenu')?.addEventListener('click', () => {
    $('mobileMenu')?.classList.add('open');
  });
  $('closeMenu')?.addEventListener('click', () => {
    $('mobileMenu')?.classList.remove('open');
  });
}

/* ---- QUICK ADD (product grid cards) ---- */
function initQuickAdd() {
  document.addEventListener('click', e => {
    // Toggle variant picker
    const toggleBtn = e.target.closest('[data-toggle-picker]');
    if (toggleBtn) {
      const productId = toggleBtn.dataset.togglePicker;
      const picker = document.getElementById('picker-' + productId);
      if (!picker) return;
      const isOpen = picker.classList.contains('open');
      // Close all open pickers
      document.querySelectorAll('.card-picker.open').forEach(p => p.classList.remove('open'));
      document.querySelectorAll('[data-toggle-picker].picker-active').forEach(b => b.classList.remove('picker-active'));
      if (!isOpen) {
        picker.classList.add('open');
        toggleBtn.classList.add('picker-active');
      }
      return;
    }

    // Direct add to cart (single-variant or picker option)
    const btn = e.target.closest('[data-quick-add]');
    if (btn) {
      // Close picker after selecting a variant
      const picker = btn.closest('.card-picker');
      if (picker) {
        picker.classList.remove('open');
        const card = picker.closest('.card');
        card?.querySelector('[data-toggle-picker]')?.classList.remove('picker-active');
      }
      addToCart(btn.dataset.variantId, 1, btn);
    }
  });

  // Close pickers when clicking outside a card
  document.addEventListener('click', e => {
    if (!e.target.closest('.card')) {
      document.querySelectorAll('.card-picker.open').forEach(p => p.classList.remove('open'));
      document.querySelectorAll('[data-toggle-picker].picker-active').forEach(b => b.classList.remove('picker-active'));
    }
  });
}

/* ---- INIT ---- */
document.addEventListener('DOMContentLoaded', () => {
  // Cart open/close
  $('openCart')?.addEventListener('click', openCart);
  $('closeCart')?.addEventListener('click', closeCart);
  overlay?.addEventListener('click', closeCart);

  initMobileMenu();
  initQuickAdd();
  initProductPage();
});
